var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',{staticClass:"page-demo-playground-fullscreen",attrs:{"type":"card"}},[_c('template',{slot:"header"},[_vm._v("全屏")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.toggle}},[_vm._v("\n    toggle 切换全屏\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }